<!-- 查询月票类型详情列表接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {

                },
          responseCode: {
            "data": {

            },
            "message": "业务成功",
            "resultCode": 0,
            "status": 1
          },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 查询将要过期的月票",
                t_url: this.commonUrls.test + "getWillExpireMonthTicketBill",
                p_url: this.commonUrls.prod + "getWillExpireMonthTicketBill",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        { info1: 'validFrom', info2: '否', info3: 'String', info4: '有效期起始时间，yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '否', info3: 'String', info4: '有效期结束时间，yyyyMMddHHmmss' },
                      { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                      { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条，默认10' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '月票类型列表' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总记录数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前数' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'validStatus', info2: '是', info3: 'Integer', info4: '有效状态' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'periods', info2: '否', info3: 'JSONArray', info4: '有效范围' },
                        { info1: 'carCodeVos', info2: '否', info3: 'JSONArray', info4: '车辆信息' },
                    ]
                },{
                    titleName: 'periods',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效期起始时间，yyyyMMddHHmmss' },
                      { info1: 'validTo', info2: '是', info3: 'String', info4: '有效期结束时间，yyyyMMddHHmmss' },
                        ]
                },{
                    titleName: 'carCodeVos',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'monthTicketBillId', info2: '是', info3: 'String', info4: '月票id' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getWillExpireMonthTicketBill.vue